// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Edit = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Edit = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Edit = _exports.Edit = function Edit(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3.03787 13.3202L2.30789 15.7989L1.91433 17.1383C1.83499 17.4081 1.90798 17.6969 2.10476 17.8937C2.30154 18.0905 2.59036 18.1635 2.85696 18.0873L4.19949 17.6906L6.67825 16.9606C7.0718 16.8463 7.43044 16.6464 7.73831 16.3766C7.78274 16.3385 7.824 16.2972 7.86526 16.256L17.52 6.60437C18.2151 5.9093 18.3008 4.83972 17.7803 4.04944C17.7073 3.93835 17.6184 3.83044 17.52 3.73206L16.2696 2.47839C15.4761 1.68494 14.1907 1.68494 13.3972 2.47839L3.74246 12.1332C3.41238 12.4633 3.17117 12.8727 3.03787 13.3202ZM4.49783 13.7487C4.55178 13.5709 4.64065 13.4059 4.76443 13.2662C4.78347 13.2472 4.79934 13.2281 4.81838 13.2091L12.0706 5.96008L14.0384 7.92786L6.78933 15.1801C6.64016 15.3292 6.45291 15.4403 6.24978 15.5006L5.5071 15.7196L3.76785 16.2306L4.27883 14.4913L4.49783 13.7487Z",
      fill: "currentColor"
    }));
  };
});
